import React from "react";
import { Navigate } from "react-router-dom";
import { connect } from "react-redux";

const AdminRoute = ({
  component,
  path,
  children,
  isLoggedIn,
  loading,
  userdata,
  userInfo,
  ...rest
}) => {
  if (!isLoggedIn && !loading) {
    localStorage.clear();
    return <Navigate to="/login" replace />;
  }
  if (userInfo.user.role === "admin") {
    return children;
  }

  return <Navigate to="/not-authorized" replace />;
};

function mapStateToProps(state) {
  const { isLoggedIn, loading, userInfo } = state.LoginSlice;
  return {
    isLoggedIn,
    loading,
    userInfo
  };
}

export default connect(mapStateToProps)(AdminRoute);
